/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ENUM_CONSULTATION_STATUS {
  DONE = "DONE",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
}

export enum ENUM_PARTNER_STATUS {
  DONE = "DONE",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
}

export enum ENUM_REFUNDREQUEST_EMAILSTATUS {
  AWAIT_1 = "AWAIT_1",
  CREATED_2 = "CREATED_2",
  DO_NOT_NEED_5 = "DO_NOT_NEED_5",
  ERROR_4 = "ERROR_4",
  SENDED_3 = "SENDED_3",
}

export enum ENUM_REFUNDREQUEST_ORDERSTATUS {
  DONE = "DONE",
  ERROR = "ERROR",
  NEW = "NEW",
  WAITING = "WAITING",
}

export enum ENUM_REFUNDREQUEST_SIGNSENDSTATUS {
  CREATED_1 = "CREATED_1",
  DO_NOT_NEED_4 = "DO_NOT_NEED_4",
  ERROR_3 = "ERROR_3",
  SENDED_2 = "SENDED_2",
}

export enum ENUM_REFUNDREQUEST_SIGNSTATUS {
  CREATED_1 = "CREATED_1",
  DONE_4 = "DONE_4",
  DO_NOT_NEED_6 = "DO_NOT_NEED_6",
  ERROR_5 = "ERROR_5",
  IN_PROGRESS_3 = "IN_PROGRESS_3",
  SIGNED_2 = "SIGNED_2",
}

export enum ENUM_REFUNDREQUEST_STATUS {
  ARCHIVE_6 = "ARCHIVE_6",
  AWAIT_4 = "AWAIT_4",
  DONE_5 = "DONE_5",
  NEW_1 = "NEW_1",
  READY_2 = "READY_2",
  WORK_3 = "WORK_3",
}

export enum ENUM_REFUNDREQUEST_TEMPLATE {
  CERT_NUMBER_ERROR = "CERT_NUMBER_ERROR",
  DEFAULT_REQUEST = "DEFAULT_REQUEST",
  DEFAULT_REQUEST_INS = "DEFAULT_REQUEST_INS",
  FIN_PROTECTION = "FIN_PROTECTION",
  FIN_PROTECTION_DATE = "FIN_PROTECTION_DATE",
  FIO_ERROR = "FIO_ERROR",
  NON_RETURN = "NON_RETURN",
  ON_PERSONAL = "ON_PERSONAL",
  PURCHASE_PLACE = "PURCHASE_PLACE",
  SEVEN_DAYS = "SEVEN_DAYS",
  SMS_REQUEST = "SMS_REQUEST",
  WALK_TO_MAIL = "WALK_TO_MAIL",
  WALK_TO_MFO = "WALK_TO_MFO",
  WALK_TO_OFFICE = "WALK_TO_OFFICE",
}

export enum ENUM_REFUNDREQUEST_TYPE {
  free = "free",
  vip = "vip",
}

export interface ActivateInput {
  Certificate_Number?: string | null;
  Certificate_Date?: any | null;
  Device_Type?: string | null;
  Device_Name?: string | null;
  Device_Number?: string | null;
  FIO?: string | null;
  Phone?: string | null;
  Email?: string | null;
  termsAccepted?: boolean | null;
  adAccepted?: boolean | null;
}

export interface ConsultationInput {
  Certificate_Number?: string | null;
  Certificate_Date?: any | null;
  FIO?: string | null;
  Phone?: string | null;
  status?: ENUM_CONSULTATION_STATUS | null;
  termsAccepted?: boolean | null;
  adAccepted?: boolean | null;
}

export interface LossInput {
  FIO?: string | null;
  Phone?: string | null;
  Certificate_Number?: string | null;
  Certificate_Date?: any | null;
  Comment?: string | null;
  Email?: string | null;
  termsAccepted?: boolean | null;
  adAccepted?: boolean | null;
}

export interface PartnerInput {
  FIO?: string | null;
  Company?: string | null;
  Phone?: string | null;
  status?: ENUM_PARTNER_STATUS | null;
  INN?: string | null;
  Email?: string | null;
}

export interface RefundRequestInput {
  status?: ENUM_REFUNDREQUEST_STATUS | null;
  requestPdfFileUrl?: string | null;
  requestData?: any | null;
  validationErrorMessage?: string | null;
  template?: ENUM_REFUNDREQUEST_TEMPLATE | null;
  type?: ENUM_REFUNDREQUEST_TYPE | null;
  orderNumber?: string | null;
  orderStatus?: ENUM_REFUNDREQUEST_ORDERSTATUS | null;
  orderLink?: string | null;
  FIO?: string | null;
  Phone?: string | null;
  Email?: string | null;
  orderValue?: number | null;
  application?: boolean | null;
  details?: boolean | null;
  Certificate_Number?: string | null;
  signStatus?: ENUM_REFUNDREQUEST_SIGNSTATUS | null;
  signCode?: string | null;
  signSendStatus?: ENUM_REFUNDREQUEST_SIGNSENDSTATUS | null;
  signDate?: any | null;
  emailStatus?: ENUM_REFUNDREQUEST_EMAILSTATUS | null;
  rawHeaders?: any | null;
  termsAccepted?: boolean | null;
  adAccepted?: boolean | null;
}

export interface recordActivateInput {
  code: string;
  email: string;
}

export interface smsActivateInput {
  code: string;
  email: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
